module.exports = __webpack_public_path__ + "img/remove_full_watermark.d18c016c.jpg";